import imageCompression from 'browser-image-compression';

const loadImageSize = src =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve({ width: image.width, height: image.height });
    image.onerror = reject;
    image.src = src;
  });

const imageEntry = (idx, file, src, { width, height }) => ({
  idx,
  file,
  src,
  origSrc: src,
  croppedSrc: src,
  width,
  height,
  aspectRatio: width / height,
  croppingBox: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width,
    height,
    scale: 1,
    aspectRatio: width / height,
  },
});

export const revokePreviewObjectUrls = images => {
  images?.forEach(img => {
    if (typeof img?.origSrc === 'string' && img.origSrc.startsWith('blob:')) {
      URL.revokeObjectURL(img.origSrc);
    }
  });
};

const compressImages = async files => {
  const blobUrls = [];
  try {
    return await Promise.all(
      files.map(async (file, idx) => {
        if (file.type === 'image/gif') {
          const src = URL.createObjectURL(file);
          blobUrls.push(src);
          return imageEntry(idx, file, src, await loadImageSize(src));
        }
        if (file.type.startsWith('image/')) {
          const options = {
            maxWidthOrHeight: 1600,
            useWebWorker: true,
            fileType: 'image/jpeg',
            quality: 1,
          };
          const blob = await imageCompression(file, options);
          const dataUrl = await imageCompression.getDataUrlFromFile(blob);
          return imageEntry(idx, file, dataUrl, await loadImageSize(dataUrl));
        }
        return { idx, file };
      }),
    );
  } catch (error) {
    blobUrls.forEach(url => URL.revokeObjectURL(url));
    throw error;
  }
};

export default compressImages;
